import SpeckleLogoSvg from "../speckle-logo.svg";

export default function SpeckleTitle() {
  return (
    <div className="font-medium text-blue-700">
      <SpeckleLogoSvg className="mr-2 inline w-5" />
      Speckle
    </div>
  );
}
